import { get, post } from '../api';

export function getWebsite() {
  return get('/websites');
}

export function getWebsiteSection(type) {
  return get(`/websites/${type}`);
}

export function postContact(data) {
  return post('/contact', data);
}


// WEBPACK FOOTER //
// ./src/website/website.service.js